import { cx } from '@emotion/css';
import { Row } from 'antd';
import { Color } from 'src/styles';

import { CurrencyRangeField } from '../CurrencyRangeField/CurrencyRangeField';
import { MTypography } from '../MTypography/MTypography';

import * as Styles from './ThisOfferOrderWillDisclaimer.styles';

export interface ThisOfferOrderWillDisclaimerProps {
  min?: number;
  max?: number;
  className?: string;
  testId?: string;
}

export const ThisOfferOrderWillDisclaimer = ({
  min,
  max,
  testId,
  className = '',
}: ThisOfferOrderWillDisclaimerProps) => {
  return (
    <Row className={cx(Styles.container, className)}>
      <MTypography variant='body1' color={Color.Gray7} testId={testId}>
        This order will be automatically submitted if the final offering price is within the estimated share range of{' '}
        <CurrencyRangeField min={min} max={max} />
      </MTypography>
    </Row>
  );
};
